import { ReactNode } from "react";
import { MoreInfoTooltipDynamicForms } from "../../elements/Tooltip";
import { mapClasses } from "../../utils/styles";
import "./style.scss";

export type FormItemProps = {
  children: ReactNode;
  label?: string;
  vertical?: boolean;
  reversed?: boolean;
  classes?: string;
  required?: boolean;
  moreInfo?: string;
  link?: { label: string; href: string; target: string };
  labelClass?: string;
  optionalMessage?: string;
};

export const FormItem = ({
  label,
  children,
  reversed,
  vertical,
  classes = "",
  required = false,
  moreInfo,
  link,
  labelClass = "",
  optionalMessage = '(Optional)',
}: FormItemProps) => {
  const mappedClasses = mapClasses({ reversed, vertical });

  return (
    <div className={`tru-form-item ${mappedClasses} ${classes}`}>
      <label className={labelClass}>
        {label || ""}
        {link && (
          <a href={link.href} target={link.target}>
            {link.label}
          </a>
        )}
        {!required && <span className="required"> {optionalMessage}</span>}
        {moreInfo && <MoreInfoTooltipDynamicForms moreInfo={moreInfo} />}
      </label>
      {children}
    </div>
  );
};
